var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoWalletHistory = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_history",
    d: "M-35.2,320.6a1.247,1.247,0,0,0,1.214-1.276v-2.838a1.247,1.247,0,0,0-1.214-1.276h-6.549a1.2,1.2,0,0,0-.394.069,1.2,1.2,0,0,0-.424.266,1.3,1.3,0,0,0-.4.942v2.838a1.3,1.3,0,0,0,.4.942,1.15,1.15,0,0,0,.424.264,1.174,1.174,0,0,0,.394.07Zm-2.534-2.865a.623.623,0,0,1,.607-.637h.4a.594.594,0,0,1,.374.137.635.635,0,0,1,.233.5v.424a.624.624,0,0,1-.607.638h-.4a.623.623,0,0,1-.607-.638Zm13.1-.762a5.651,5.651,0,0,0-5.675,5.613,5.65,5.65,0,0,0,5.675,5.612,5.65,5.65,0,0,0,5.675-5.612A5.651,5.651,0,0,0-24.633,316.97Zm2.372,8.356a.879.879,0,0,1-1.234,0l-2.131-1.943a.856.856,0,0,1-.256-.61v-3.066a.869.869,0,0,1,.873-.863.868.868,0,0,1,.873.863v2.708l1.875,1.69A.854.854,0,0,1-22.261,325.326Zm-9.076.14h-9.3a1.134,1.134,0,0,1-1.105-1.162h0v-2.46c.063,0,.125.016.187.016H-35.2a2.48,2.48,0,0,0,2.415-2.537v-2.838a2.481,2.481,0,0,0-2.415-2.538h-6.361c-.063,0-.125.011-.187.017v-2.6a1.133,1.133,0,0,1,1.1-1.163h15.452a1.117,1.117,0,0,1,1.066.858,1.208,1.208,0,0,1,.039.3v4.02c-.181-.013-.361-.027-.545-.027a7.283,7.283,0,0,0-7.315,7.233A7.119,7.119,0,0,0-31.338,325.466Z",
    transform: "translate(42.958 -310.194)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoWalletHistory);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_wallet_history.fb20fd339103b76b016b122b3318d9ab.svg";